require('../../../retail/shared/wdh-legacy/online-booking/js/base/a-datepicker-regionals.js');
require('../../../retail/shared/wdh-legacy/online-booking/js/base/component-online-booking.js');